





























import { Component } from 'vue-property-decorator';
import { AppMediumsModule } from '@/store/Settings/AppMediumsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import AppMediumDetails from '@/components/Settings/AppMediums/AppMediumDetails.vue';

@Component({ name: 'AppMedium', components: { Alert, AppMediumDetails }, metaInfo: { title: 'App Mediums' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
        await AppMediumsModule.getAppMedium(this.$route.params.id);
    }

    get appMedium() {
        return AppMediumsModule.appMedium;
    }

    get loading() {
        return AppMediumsModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
